import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <rect x="3" y="3" width="18" height="2.4" rx="1.2" />
        <rect x="3" y="7.6" width="18" height="2.4" rx="1.2" />
        <rect x="3" y="12.2" width="18" height="2.4" rx="1.2" opacity=".45" />
        <path d="M12 22l-4-4h2.8v-2h2.4v2H16l-4 4z" />
      </svg>
    ),
  },
});
